import "./src/styles/global.css"
import "./src/styles/patient/Patient.scss"

import React from "react";

export const onRenderBody = ({ setHeadComponents }) => {
    setHeadComponents([
        <link rel="icon" href="/favicon.ico" key="favicon" />,
        <link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png" key="favicon32" />,
        <link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png" key="favicon16" />,
    ]);
};


